// src/pages/merchant/dashboard/VisitingCardModule.jsx
import React, { useEffect, useState } from "react";
import BasicCardBg from "../../../../assets/images/visiting-card.jpg";
import "../visitingcard.css";
import EditCommentModal from "./EditCommentModal";
import VisitingCardModal from "../VisitingCardModal";
import { useDispatch, useSelector } from "react-redux";
import html2canvas from "html2canvas";
import { setAdvertisingCard } from "../../../../features/advertisement/advtCardSlice";
import { useNavigate } from "react-router-dom";
import CustomizedCardRequest from "../CustomizedCardRequest";
import {
  fetchLanguagesThunk,
  fetchLanguageDetailsThunk,
  fetchAllCardsThunk,
} from "../../../../features/eVisitingCard/VisitingCard.thunk";

const UserVisitingCardModule = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { languages, languageDetail, professionalTemplate } = useSelector( 
  (state) => state.eCard
  );
const COMMENT_KEY = "basic_card_comment";
  const [comment, setComment] = useState("");
  const [showEditCommentModal, setShowEditCommentModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("");

  // Promotional card state
 const [promoColor, setPromoColor] = useState(() => {
  const stored = localStorage.getItem("promoCardColor");
  return stored ? (stored.startsWith("#") ? stored : `#${stored}`) : "#000000";
});

  const [promoBg, setPromoBg] = useState(
    localStorage.getItem("promoCardBg")
      ? `${process.env.REACT_APP_IMAGE_BASE_URL.replace(/\/$/, "")}${localStorage.getItem(
          "promoCardBg"
        )}`
      : BasicCardBg
  );

  // Auto-select English as default language
useEffect(() => {
  if (languages?.length && !selectedLanguage) {
    const englishLang = languages.find(
      (lang) => lang.name.toLowerCase() === "english"
    );

    if (englishLang) {
      setSelectedLanguage(englishLang._id);
      dispatch(fetchLanguageDetailsThunk(englishLang._id));
    }
  }
}, [languages, selectedLanguage, dispatch]);

  // Load initial data
  useEffect(() => {
    dispatch(fetchAllCardsThunk());
    dispatch(fetchLanguagesThunk());
  }, [dispatch]);

  const handleLanguageChange = (langId) => {
    setSelectedLanguage(langId);
    dispatch(fetchLanguageDetailsThunk(langId));
  };

  const user = languageDetail?.userDetail || {};
  const labels = languageDetail?.cardLabel || {};

  const waitForImages = async (container) => {
  const images = container.querySelectorAll("img");
  await Promise.all(
    Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) return resolve();
          img.onload = resolve;
          img.onerror = resolve;
        })
    )
  );
};

  /**
   * Safe professional image loader
   * @returns {string} The full URL of the professional template image or a default fallback.
   */
  const getProfessionalImage = () => {
    if (!professionalTemplate || !professionalTemplate.templateImage) {
      return BasicCardBg;
    }
    return `${process.env.REACT_APP_IMAGE_BASE_URL.replace(
      /\/*$/,
      ""
    )}${professionalTemplate.templateImage}`;
  };

   // Converts HEX text color code → readable CSS color
const getTextColor = (hex) => {
  if (!hex) return "#000000"; // fallback
  if (hex.startsWith("#")) return hex;
  return `#${hex}`;
};

const preloadImage = (src) =>
  new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = src;
    img.onload = resolve;
  });

// advertise click
const handleAdvertiseClick = async (cardType, cardElementId) => {
  const cardElement = document.getElementById(cardElementId);
  if (!cardElement) return;

  // Get background image
  let bgImage = cardElement.style.backgroundImage;
  if (bgImage && bgImage !== "none") {
    bgImage = bgImage.replace(/url\(|\)|"|'/g, "");
    if (bgImage) {
      await preloadImage(bgImage);
    }
  }

  const canvas = await html2canvas(cardElement, {
    scale: 2,
    useCORS: true,
    allowTaint: false,
  });

  const imageBase64 = canvas.toDataURL("image/png");

  dispatch(
    setAdvertisingCard({
      cardType,
      cardImage: imageBase64,
    })
  );

  navigate("/dashboard/card-advertising");
};

  // --- DYNAMICALLY DETERMINE PROFESSIONAL CARD COLOR/BG ---
  const professionalCardColor = getTextColor(professionalTemplate?.colorCode);
  const professionalCardImage = getProfessionalImage();
  // --------------------------------------------------------

  // download and share card 
const downloadCard = async (cardElementId) => {
  const cardElement = document.getElementById(cardElementId);
  if (!cardElement) return;

  await waitForImages(cardElement);

  const canvas = await html2canvas(cardElement, {
    scale: 2,
    useCORS: true,
    backgroundColor: null,
  });

  const image = canvas.toDataURL("image/png");
  const link = document.createElement("a");
  link.href = image;
  link.download = "visiting-card.png";
  link.click();
};

// share card 
const shareCard = async (cardElementId) => {
  const cardElement = document.getElementById(cardElementId);
  if (!cardElement) return;

  await waitForImages(cardElement);

  const canvas = await html2canvas(cardElement, {
    scale: 2,
    useCORS: true,
    backgroundColor: null,
  });

  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, "image/png")
  );

  const file = new File([blob], "visiting-card.png", {
    type: "image/png",
  });

  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({
      title: "My Visiting Card",
      text: "Check out my visiting card",
      files: [file],
    });
  } else {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "visiting-card.png";
    a.click();
    URL.revokeObjectURL(url);
  }
};



  /* ---------------- LOAD COMMENT FROM STORAGE ---------------- */
  useEffect(() => {
    const saved = localStorage.getItem(COMMENT_KEY);
    if (saved) setComment(saved);
  }, []);

  /* ---------------- UPDATE COMMENT ---------------- */
  const updateComment = (text) => {
    setComment(text);
    localStorage.setItem(COMMENT_KEY, text);
  };

  return (
    <div className="visiting-card-container">
      {/* Modal */}
      <VisitingCardModal
        show={showModal}
        onHide={() => setShowModal(false)}
       onSelectTemplate={(imgPath, colorCode) => {
  const formattedColor = colorCode.startsWith("#") ? colorCode : `#${colorCode}`;

  localStorage.setItem("promoCardBg", imgPath);
  localStorage.setItem("promoCardColor", formattedColor);

  setPromoBg(`${process.env.REACT_APP_IMAGE_BASE_URL.replace(/\/$/, "")}${imgPath}`);
  setPromoColor(formattedColor);  }} />
      <div className="header-section">
        <h1>Visiting Cards</h1>
      </div>

      <div className="content-wrapper">
        {/* ------------------------ PROFESSIONAL CARD ------------------------ */}
        <div className="card-section">
          <h2 className="section-title">Professional Visiting Card</h2>
          <div className="language-selection-wrapper">
            <select 
            className="language-selector"
            value={selectedLanguage}
            onChange={(e) => handleLanguageChange(e.target.value)}>
              <option value="">Select Language</option>
              {languages.map((lang) => (
                <option key={lang._id} value={lang._id}>
                  {lang.name}
                </option>
              ))}
            </select>
          </div>

             <div id="basicCardPreview" className="visiting-card">
        <div
          className="card-basic"
          style={{
            backgroundImage: `url(${professionalCardImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: getTextColor(professionalTemplate?.colorCode),
          }}
        >
          {/* HEADER */}
          <div className="card-header-text fw-bold">
            {user.fullName || "User Name"}
          </div>

       <div className="card-sub-info">
  <span className="email">{user.email}</span>
  <span className="mobile">{user.mobileNumber}</span>
</div>

          {/* MIDDLE */}
          <div className="card-middle">
            <div className="card-logo">
              <img
                src={`${process.env.REACT_APP_IMAGE_BASE_URL.replace(/\/$/, "")}${user.profileImage}`}
                alt="profile"
                crossOrigin="anonymous"
                className="placeholder-logo"
              />
            </div>

            {/* COMMENT TEXT (CLICKABLE) */}
            <div
              className="card-comment"
              onClick={() => setShowEditCommentModal(true)}
            >
              {comment || "// Add your Comments (Business Detail)"}
            </div>
          </div>

          {/* FOOTER */}
          <div
            className="card-footer-info"
            style={{ color: getTextColor(professionalTemplate?.colorCode) }}
          >
            <div>
              {labels.addressLabel || "Address"}: {user.address || ""}
            </div>
          </div>
        </div>
      </div>

          <div className="action-buttons">
           <button
  className="btn-action btn-download"
  onClick={() => downloadCard("basicCardPreview")}
>
  ⬇ Download
</button>
            <button
              className="btn-action btn-advertise"
              onClick={() =>
                handleAdvertiseClick("Basic Professional", "basicCardPreview")
              }> 📢 Advertise </button>

           <button
  className="btn-action btn-share"
  onClick={() => shareCard("basicCardPreview")}
>
  ↗ Share
</button>
          </div>
        </div>

        {/* ------------------------ PROMOTIONAL CARD ------------------------ */}
        <div className="card-section">
          <h2 className="section-title">Promotional Visiting Card</h2>

          <div className="language-selection-wrapper">
            <select
              className="language-selector"
              value={selectedLanguage}
              onChange={(e) => handleLanguageChange(e.target.value)}
            >
              <option value="">Select Language</option>
              {languages.map((lang) => (
                <option key={lang._id} value={lang._id}>
                  {lang.name}
                </option>
              ))}
            </select>
          </div>

          <div id="promoCardPreview" className="visiting-card">
            <div
          className="card-promotional"
          style={{
          backgroundImage: `url(${promoBg})`,
          backgroundSize: "cover",
          color: getTextColor(promoColor),  
          crossOrigin:"anonymous",
      }}>
              <div className="promo-business fw-bold">
                {user.businessName || "Business Name"}
              </div>

              <div className="promo-footer">
                <div className="promo-logo">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL.replace(/\/$/, "")}${user.profileImage}`}
                   crossOrigin="anonymous"
                    alt="logo"
                    className="placeholder-logo"
                  />
                </div>

                <div className="promo-info">
                  <div>{user.fullName}</div>
                  <div>{user.businessName}</div>
                  <div>{user.mobileNumber}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="action-buttons">
           <button
         className="btn-action btn-download"
         onClick={() => downloadCard("promoCardPreview")}
           >
          ⬇ Download
         </button>
            <button
              className="btn-action btn-advertise"
              onClick={() =>
                handleAdvertiseClick(
                  "Classic Promotional",
                  "promoCardPreview"
                )
              }>📢 Advertise </button>
            <button className="btn-action btn-share" onClick={() => shareCard("promoCardPreview")}> ↗ Share </button>
          </div>

          <button className="customize-btn" onClick={() => setShowModal(true)}>
            🎨 Customize Promotional Card
          </button>
        </div>


         {/* EDIT MODAL */}
      <EditCommentModal
        open={showEditCommentModal}
        initialValue={comment}
        onClose={() => setShowEditCommentModal(false)}
        onUpdate={updateComment} />
      <div className="card-section">
         <CustomizedCardRequest />
      </div>   
      </div>
      <style>
        {`.card-sub-info {
  display: flex;
  justify-content: space-between; /* email left, number right */
  align-items: center;
  gap: 12px; /* margin between them */
  width: 100%;
  font-size: 14px;
  color: #ffffff;
}

.card-sub-info .email {
  text-align: left;
  word-break: break-all; /* prevents overflow */
}

.card-sub-info .mobile {
  text-align: right;
  white-space: nowrap;
  margin-left: auto; /* pushes it to the end */
}

@media (max-width: 480px) {
  .card-sub-info {
    align-items: flex-start;
    gap: 6px;
  }

  .card-sub-info .mobile {
    margin-left: 0;
    align-self: flex-end;
  }
}

`}
      </style>
    </div>


  );
};

export default UserVisitingCardModule;